import React, { useEffect } from 'react'

const Dashboard = () => {

    useEffect(() => {
        document.title = 'Durga College Admin panel';
    }, [])

    return (
        <div className="home-page">
            <h1>Welcome to Durga College Admin Panel</h1>
        </div>
    )
}

export default Dashboard
